export default "__VITE_ASSET__44084667__";